
const indicators = globalThis.SSIndicators;
if (!indicators) {
    throw new Error(
        'SSChart: @stocksharp/indicators is missing. Load dist/ssindicators.js before this script '
        + '(it publishes the SSIndicators global).');
}
module.exports = indicators;
